export const browImages = [
    {
        name: 'BrowsOne',
        src: require('../AvatarImg/Brows1.svg').default,
    },
    {
        name: 'BrowsTwo',
        src: require('../AvatarImg/Brows2.svg').default,
    },
    {
        name: 'BrowsThree',
        src: require('../AvatarImg/Brows3.svg').default,
    },
    {
        name: 'BrowsFour',
        src: require('../AvatarImg/Brows4.svg').default,
    },
    {
        name: 'BrowsFive',
        src: require('../AvatarImg/Brows5.svg').default,
    },
]

export const hairImages = [
    {
        name: 'HairOne',
        src: require('../AvatarImg/Hair1.svg').default,
    },
    {
        name: 'HairTwo',
        src: require('../AvatarImg/Hair2.svg').default,
    },
    {
        name: 'HairThree',
        src: require('../AvatarImg/Hair3.svg').default,
    },
    {
        name: 'HairFour',
        src: require('../AvatarImg/Hair4.svg').default,
    },
    {
        name: 'HairFive',
        src: require('../AvatarImg/Hair5.svg').default,
    },
]

export const eyesImages = [
    {
        name: 'EyesOne',
        src: require('../AvatarImg/Eyes1.svg').default,
    },
    {
        name: 'EyesTwo',
        src: require('../AvatarImg/Eyes2.svg').default,
    },
    {
        name: 'EyesThree',
        src: require('../AvatarImg/Eyes3.svg').default,
    },
    {
        name: 'EyesFour',
        src: require('../AvatarImg/Eyes4.svg').default,
    },
    {
        name: 'EyesFive',
        src: require('../AvatarImg/Eyes5.svg').default,
    },
]

export const noseImages = [
    {
        name: 'NoseOne',
        src: require('../AvatarImg/Nose1.svg').default,
    },
    {
        name: 'NoseTwo',
        src: require('../AvatarImg/Nose2.svg').default,
    },
    {
        name: 'NoseThree',
        src: require('../AvatarImg/Nose3.svg').default,
    },
    {
        name: 'NoseFour',
        src: require('../AvatarImg/Nose4.svg').default,
    },
    {
        name: 'NoseFive',
        src: require('../AvatarImg/Nose5.svg').default,
    },
]

export const mouthImages = [
    {
        name: 'MouthOne',
        src: require('../AvatarImg/Mouth1.svg').default,
    },
    {
        name: 'MouthTwo',
        src: require('../AvatarImg/Mouth2.svg').default,
    },
    {
        name: 'MouthThree',
        src: require('../AvatarImg/Mouth3.svg').default,
    },
    {
        name: 'MouthFour',
        src: require('../AvatarImg/Mouth4.svg').default,
    },
    {
        name: 'MouthFive',
        src: require('../AvatarImg/Mouth5.svg').default,
    },
]
